import { memo } from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';
import { BarChart, PieChart as PieChartIcon, LineChart as LineChartIcon, AreaChart as AreaChartIcon, ScatterChart as ScatterChartIcon, Activity, Loader2 } from 'lucide-react';

export default memo(({ data, selected }: any) => {

    // Determine Icon based on visual type
    const getIcon = () => {
        const cls = "w-7 h-7 text-white transition-transform duration-300 group-hover:scale-110";
        switch (data.visualType) {
            case 'line': return <LineChartIcon className={cls} strokeWidth={1.5} />;
            case 'pie': return <PieChartIcon className={cls} strokeWidth={1.5} />;
            case 'area': return <AreaChartIcon className={cls} strokeWidth={1.5} />;
            case 'scatter': return <ScatterChartIcon className={cls} strokeWidth={1.5} />;
            case 'combo': return <Activity className={cls} strokeWidth={1.5} />;
            default: return <BarChart className={cls} strokeWidth={1.5} />;
        }
    };

    const isRunning = data.executionStatus === 'Running';

    return (
        <div className="relative flex flex-col items-center">
            <NodeResizer
                color="#60a5fa"
                isVisible={selected}
                minWidth={48}
                minHeight={48}
                handleStyle={{ width: 8, height: 8, borderRadius: 2 }}
            />

            {/* Main Node Container - Blue Theme matching BaseNodeUI shape */}
            <div
                className={`
                    relative group flex items-center justify-center
                    w-14 h-14 min-w-[56px] min-h-[56px] rounded-2xl shadow-md border-[1.5px] transition-all duration-300 z-10
                    bg-blue-900 border-blue-700
                    ${selected ? 'border-white ring-4 ring-blue-500/30 scale-105' : 'hover:border-blue-500 hover:shadow-lg hover:-translate-y-0.5'}
                `}
            >
                {/* Main Icon */}
                {getIcon()}

                {/* Running Spinner */}
                {isRunning && (
                    <div className="absolute top-1 right-1 p-0.5 bg-white/10 backdrop-blur-[1px] rounded-full z-20">
                        <Loader2 className="h-3 w-3 text-white animate-spin" />
                    </div>
                )}

                {/* Input Handle (Left) */}
                <Handle
                    type="target"
                    position={Position.Left}
                    className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                    style={{ left: -14 }}
                >
                    <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-blue-400 rotate-45 transform -translate-x-0.5" />
                </Handle>

                {/* Output Handle (Right) */}
                <Handle
                    type="source"
                    position={Position.Right}
                    className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                    style={{ right: -14 }}
                >
                    <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-blue-400 rotate-45 transform -translate-x-0.5" />
                </Handle>
            </div>

            {/* Label Below Node */}
            <div className="mt-1 text-[9px] font-bold text-slate-500 uppercase tracking-wider text-center max-w-[90px] leading-none select-none">
                {data.label || 'Visual'}
            </div>
        </div >
    );
});
